import React from 'react';
import '../styles/pages/About.css';

function About() {
  return (
    <div className="about">
      <div className="about-header">
        <h1>About HZ Landscaping</h1>
        <p>Transforming outdoor spaces since day one</p>
      </div>

      <div className="container">
        <section className="mission-section">
          <h2>Our Mission</h2>
          <p>
            At HZ Landscaping, we believe that every outdoor space has potential. Our mission is to
            design and maintain beautiful, functional landscapes that enhance your property and quality of life.
            We combine professional expertise with personalized service to bring your outdoor vision to life.
          </p>
        </section>

        <section className="why-choose-section">
          <h2>Why Choose HZ Landscaping?</h2>
          <div className="reasons-grid">
            <div className="reason-card">
              <h3>🎯 Expertise</h3>
              <p>
                With years of experience in landscaping design and maintenance, our team knows
                what works and what creates lasting beauty.
              </p>
            </div>
            <div className="reason-card">
              <h3>💼 Professionalism</h3>
              <p>
                We treat every project with care and attention to detail. Your satisfaction is
                our top priority.
              </p>
            </div>
            <div className="reason-card">
              <h3>🔧 Comprehensive Services</h3>
              <p>
                From design and installation to ongoing maintenance, we handle every aspect of
                your landscaping needs.
              </p>
            </div>
            <div className="reason-card">
              <h3>⏰ Reliability</h3>
              <p>
                We show up on time, complete work on schedule, and maintain open communication
                throughout every project.
              </p>
            </div>
            <div className="reason-card">
              <h3>🌿 Quality Materials</h3>
              <p>
                We use only the finest materials and plants to ensure your landscape looks
                beautiful and lasts for years.
              </p>
            </div>
            <div className="reason-card">
              <h3>💰 Fair Pricing</h3>
              <p>
                Transparent pricing with no hidden costs. We provide quality service at competitive rates.
              </p>
            </div>
          </div>
        </section>

        <section className="values-section">
          <h2>Our Values</h2>
          <ul className="values-list">
            <li><strong>Quality:</strong> We never compromise on the quality of our work</li>
            <li><strong>Integrity:</strong> We stand by our word and commitments</li>
            <li><strong>Customer Service:</strong> Your needs and satisfaction come first</li>
            <li><strong>Environmental Responsibility:</strong> We use sustainable landscaping practices</li>
            <li><strong>Continuous Improvement:</strong> We stay current with industry best practices</li>
          </ul>
        </section>
      </div>
    </div>
  );
}

export default About;
